<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="purchaseOrders">
        <dx-data-grid
            #dataGrid
            [dataSource]="purchaseOrders"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="id" width="65"></dxi-column>
            <dxi-column dataField="pONumber" caption="PO #" width="80"></dxi-column>
            <dxi-column dataField="vendor.companyName" caption="Vendor" width="200"></dxi-column>
            <dxi-column dataField="vendorAddressDisplay" caption="Vendor Address" width="200"></dxi-column>
            <dxi-column dataField="shippingAddressDisplay" caption="Shipping" width="200"></dxi-column>
            <dxi-column dataField="createDate" caption="Order Date" width="100"></dxi-column>
            <dxi-column dataField="estimatedDelivery" caption="Est. Delivery" width="100"></dxi-column>
            <dxi-column dataField="emailed" width="100"></dxi-column>
            <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="_openBalance" caption="Open Balance" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
            <dxi-column dataField="pickups" caption="Open Pickups" width="100"  cellTemplate="pickupTemplate"></dxi-column>
            <dxi-column dataField="note" caption="Notes" width="200"></dxi-column>

            <div *dxTemplate="let item of 'columnTemplate'">
                <div style="font-weight: bold">{{ item.data.shipToLocation }}</div>
                <div>{{ item.data.shipToAddress1 }}</div>
                <div [hidden]="!item.data.shipToAddress2">{{ item.data.shipToAddress2 }}</div>
                <div>{{ item.data.shipToCity }}, {{ item.data.shipToState }} {{ item.data.shipToZip }} {{ item.data.shipToCountry }}</div>
            </div>

            <div *dxTemplate="let cell of 'pickupTemplate'">
                <a [routerLink]="['/purchase-orders/vendor-pickup/']">{{ cell.value || '' }} </a>
            </div>
            <!-- <div *dxTemplate="let cell of 'pickupTemplate'">
                <a *ngFor="let x of cell.data.pickups" [routerLink]="[]" (click)="openPurchaseOrder(x)">{{ x || '' }} </a>
            </div> -->

            <dxo-summary>
                <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="_openBalance" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button (click)="open()" class="btn btn-secondary ms-2">New</button>

                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button>
                <button (click)="toggleCompleted()" class="btn btn-sm btn-warning ms-4">
                    {{ filter.showCompleted ? 'Hide Completed' : 'Show Completed' }}
                </button>

                <button
                    class="btn btn-success ms-4"
                    (click)="createPickup(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Create Pickup
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <!-- <span class="me-3"
                    ><strong>{{ 'Open PO Total: ' + (openTotal | currency) }}</strong></span
                >
                <span *ngIf="!!purchaseOrders" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                > -->
            </div>
        </dx-data-grid>
    </div>
</div>
